/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Scopes_LabelInputs */



/**
* | output |
* | --- |
* | "Scopes:" |
*
* @param {Developer_Scopes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_scopes_label = /** @type {((inputs?: Developer_Scopes_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Scopes_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Portées :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alcances:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escopos:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scopes:")
	return /** @type {LocalizedString} */ ("Scopes:")
});